export default "__VITE_ASSET__BEeIR8K$__"